import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  Optional,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[phoneMask]',
})
export class PhoneMask implements AfterViewInit, OnDestroy {
  private inputEl!: HTMLInputElement | null;
  private unlistenInput?: () => void;

  constructor(
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Optional() private ngControl: NgControl,
  ) {}

  ngAfterViewInit(): void {
    const hostEl = this.host.nativeElement;

    if (hostEl.tagName === 'INPUT') {
      this.inputEl = hostEl as HTMLInputElement;
    } else {
      this.inputEl = hostEl.querySelector('input');
    }

    if (!this.inputEl) {
      console.warn('phoneMask: nenhum <input> encontrado no host.');
      return;
    }

    this.unlistenInput = this.renderer.listen(this.inputEl, 'input', (e: Event) => this.onInput(e));

    this.formatAndSync(this.inputEl.value, { emitToControl: false });
  }

  ngOnDestroy(): void {
    if (this.unlistenInput) this.unlistenInput();
  }

  private onInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.formatAndSync(target.value, { fromEvent: true });
  }

  private formatAndSync(
    rawValue: string,
    opts: { fromEvent?: boolean; emitToControl?: boolean } = {},
  ) {
    if (!this.inputEl) return;

    const numeric = rawValue.replace(/\D/g, '');
    const masked = this.applyPhoneMask(numeric);

    if (this.inputEl.value !== masked) {
      this.renderer.setProperty(this.inputEl, 'value', masked);
    }

    if (this.ngControl && this.ngControl.control) {
      try {
        this.ngControl.control.setValue(masked, { emitEvent: false });
      } catch (err) {}
    } else if (opts.fromEvent) {
      const ev = new Event('input', { bubbles: true, cancelable: true });
      this.inputEl.dispatchEvent(ev);
    }
  }

  private applyPhoneMask(digits: string) {
    let numbers = digits.replace(/\D/g, '');

    numbers = numbers.substring(0, 13);

    let formatted = '';

    if (numbers.length >= 1) {
      formatted += '+' + numbers.substring(0, 2);
    }

    if (numbers.length >= 3) {
      formatted += ' (' + numbers.substring(2, 4);
    }

    if (numbers.length >= 5) {
      formatted += ') ' + numbers.substring(4, 9);
    }

    if (numbers.length >= 10) {
      formatted += '-' + numbers.substring(9, 13);
    }

    return formatted;
  }
}
